import React from 'react'
import { connect } from 'react-redux'
import { addFoodItem } from '../actions/index'

class AddFoodItem extends React.Component {
    constructor() {
        super()
        this.state = {
            name: '',
            time: '',
            description: '',
            pickup_date: '',
        }
    }

    handleChange = (evt) => {
        evt.preventDefault()
        this.setState({
            [evt.target.name]: evt.target.value,
        })
    }

    handleSubmit = (evt) => {
        evt.preventDefault()
        const { name, time, description, is_claimed, pickup_date } = this.state
        this.props.addFoodItem(name, time, description, is_claimed, pickup_date)
        this.setState({ name: '', time: '', description: '', is_claimed: '', pickup_date: '', })
    }

    render() {
        const { name, time, description, pickup_date } = this.state
        return (
            <div>
                <h1 className="newpickupheader">Schedule New Pickup</h1>
                <form onSubmit={this.handleSubmit}>
                    <input type="text" name="name" value={name} placeholder="Food item name" onChange={this.handleChange} required /><br />
                    <input type="text" name="pickup_date" value={pickup_date} placeholder="Request a Pickup Date" onChange={this.handleChange} required /><br />
                    <input type="text" name="time" value={time} placeholder="Request a Pickup Time" onChange={this.handleChange} required /><br />
                    <input type="text" name="description" value={description} placeholder="Food item description" onChange={this.handleChange} required /><br />
                    <button type="submit" className="abutton2">Add Food Item for Pickup</button>
                </form>
            </div>
        )
    }
}

const mapDispatchToProps = { addFoodItem }

export default connect(null, mapDispatchToProps)(AddFoodItem)